/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftsBookedQueryResponse, GetApiBarberShiftsBookedQueryParams, GetApiBarberShiftsBooked400, GetApiBarberShiftsBooked401, GetApiBarberShiftsBooked403, GetApiBarberShiftsBooked404, GetApiBarberShiftsBooked500 } from "../entities/GetApiBarberShiftsBooked";

function getGetApiBarberShiftsBookedUrl() {
  const res = { method: 'GET', url: `/api/barber/shifts/booked` as const }
  return res
}

/**
 * @description Получить список незавершенных забронированных смен текущего мастера за период
 * @summary Забронированные смены
 * {@link /api/barber/shifts/booked}
 */
export async function getApiBarberShiftsBooked(params: GetApiBarberShiftsBookedQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberShiftsBookedQueryResponse, ResponseErrorConfig<GetApiBarberShiftsBooked400 | GetApiBarberShiftsBooked401 | GetApiBarberShiftsBooked403 | GetApiBarberShiftsBooked404 | GetApiBarberShiftsBooked500>, unknown>({ method : "GET", url : getGetApiBarberShiftsBookedUrl().url.toString(), params, ... requestConfig })
  return res.data
}